<div class="main-container">
    <div class="modal-header">
        <div class="checkin-and-phase-container">
            <span>{{data.checkinTitle}}</span>
            <div class="phase-container">
                <span>{{data.phaseTitle}}</span>
            </div>
        </div>
        <img src="../../../assets/svg/close-button.svg" class="modal-close-btn" (click)="close(false);$event.stopPropagation()">
    </div>
    <div class="modal-body">
        
    </div>
</div>